import { useAvtData } from '../AnalysisView/useAvtData'
import { useAvailableCash } from './useAvailableCash'

export const usePreloadClientAnalysis = (clientId) => {
  useAvtData(clientId)
  useAvailableCash(clientId)
}
